import { createStore } from 'vuex';
var moment = require('moment');
import * as _ from 'lodash';

const s3 = process.env.VUE_APP_S3;
const custom = process.env.VUE_APP_CUSTOM;
console.log(custom)
// Create a new store instance.
const store = createStore({
  state () {
    return {
      booking: null,
      tripBookingHotels: null,
      query: {},
      services: [],
      allServices: [],
      agentName: null,
      agentDescription: null,
      agentEmail: null,
      agentPhone: null,
      agentMeet: null,
      hotels: [],
      sellerImg: null,
      sellerImgBig: null,
      coverImg: null,
      tripName: null,
      obsevationNotes: null,
      paxName: null,
      loaded: false,
      lang: 'en',
      languageNotes: [],
      prices: [],
      fitPrices: [],
      hidePrices: false,
      coverService: null,
      coverNote: null,
      fitHotels: [],
      //fitShowPrices: false,
      fitPaxDetail: false,
      fitGuestRelation: null,
      fitStatus: null,
      flightNotes: [],
      grUser: null,
      fitPriceDetails: [],
      reference: '',
      custom: custom || "SAY",
      clientImage: null,
      userVideo: null,
      finalCustomer: false,
      paxPrincipal: null,
      replaceNotes: [],
      hotelPainting: [],
      noDateView: null,
      isUser: false,
      currencyRate: null,
      currency:null,
      modifiedUTC: null,
      expireDays: null,
    }
  },
  getters: {
    bookingCities: (state, getters) => {
      const result = [];
      const services = getters.serviceStatusList() ? getters.serviceStatusList() : state.services || [];
      if (!services || services.length === 0) return result;

      const isNumeric = (v) => !isNaN(parseFloat(v)) && isFinite(parseFloat(v));

      services
        .filter(s => !!s.Coordenadas)
        .map(s => s.Coordenadas)
        .forEach(row => {
          if (!row || typeof row !== 'string') return;
          let text = row.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '');
          const lines = text
            .split(/\n+/)
            .map(l => l.trim())
            .filter(l => l.length > 0);

          let currentName = null;

          for (const line of lines) {
            if (line.includes('|')) {
              const partsRaw = line.split('|');
              const parts = partsRaw.map(p => p.trim()).filter(p => p.length > 0);
              if (parts.length >= 2 && isNumeric(parts[0]) && isNumeric(parts[1])) {
                const lat = parseFloat(parts[0]);
                const lng = parseFloat(parts[1]);
                if (currentName && isFinite(lat) && isFinite(lng)) {
                  result.push({ Name: currentName, Latitude: lat, Longitude: lng });
                  currentName = null;
                }
                continue;
              }
              if (parts.length >= 3 && isNumeric(parts[1]) && isNumeric(parts[2])) {
                const name = parts[0];
                const lat = parseFloat(parts[1]);
                const lng = parseFloat(parts[2]);
                if (name && isFinite(lat) && isFinite(lng)) {
                  result.push({ Name: name, Latitude: lat, Longitude: lng });
                }
                currentName = null;
                continue;
              }
              continue;
            }
            currentName = line;
          }
        });

      return result;
    },
    hotelNightsBase: (state) => {
      const hotels = state.hotels || [];
      let res = _.map(hotels, (e) => {
        const checkInRaw = e?.CheckIn;
        const checkOutRaw = e?.CheckOut;
        const checkin = moment(checkInRaw);
        const checkout = moment(checkOutRaw);
        const nights = checkout.diff(checkin, 'day');
        return {
          dateString: checkInRaw,
          nights,
          location: e?.LocationCode,
          locationName: e?.LocationName,
          supplierCode: e?.SupplierCode?.trim(),
        };
      });
      res.sort((a, b) => {
        if (a.dateString > b.dateString) return 1;
        if (a.dateString < b.dateString) return -1;
        return 0;
      });
      return res;
    },
    hotelNightsByLocation: (state, getters) => {
      let values = _.filter(getters.hotelNightsBase, (h) => h.supplierCode != '3004' && h.location != '000');
      values = values.map((e) => {
        return {
          ...e,
          locationDate: `${e.locationName} - ${e.dateString}`
        };
      });
      values = _.uniqBy(values, 'locationDate');
      values = _(values)
        .groupBy('locationName')
        .map((objs, key) => ({
          locationName: key,
          nights: _.sumBy(objs, 'nights')
        }))
        .value();
      return values;
    },
    totalHotelNights: (state, getters) => {
      return _.sumBy(getters.hotelNightsByLocation, 'nights');
    },
    hotelPainting: (state, getters) => {
      const permitStatus = ['OK', 'LK', 'RM', 'IK'];
      let res = _.filter(state.hotelPainting, (h) => {
        if (h.Destination == '000') return false;
        const statusService = getters.serviceStatus(h.OPT_ID);
        if (['CX', 'RX'].includes(statusService)) return false;
        return true;
      });
      res = res.map((h) => {
        const statusService = getters.serviceStatus(h.OPT_ID);
        let nights = " "
        if (!permitStatus.includes(statusService)) {
          h["Check-in Time"] = " "
          h["Check-out Time"] = " "
          h["Room type"] = " "
          h["Hotel"] = "hotel to be assigned"
          const service = state.hotels.find(s => s.OPT_ID === h.OPT_ID);
          if (service && service != -1 &&  service.ServiceTypeCode == 'AC' && service.SupplierCode.trim() == '3004') {
            h["Hotel"] = "Hotel not included";
          }
        }
        const checkIn = moment(h["Check-in Date"], 'DD-MMM-YY');
        const checkOut = moment(h["Check-out Date"], 'DD-MMM-YY');
        nights = checkOut.diff(checkIn, 'days');
        return {
          ...h,
          "Number of nights": nights
        };
      });
      return res ? res : [];
    },
    serviceStatus: (state) => (opt_id) => {
      const priceDetail = state.fitPriceDetails.find((e) => e.OPT_ID == opt_id);
      if (priceDetail) {
        return priceDetail.SERV_STATUS_CODE;
      }
      return null;
    },
    serviceStatusList: (state, getters) => () => {
      if (!state.services || state.services.length === 0) return [];
      const filterResult = state.services.filter((r) => {
        const statusService = getters.serviceStatus(r.OPT_ID);
        if (statusService == 'CN') {
          return false;
        }
        if (statusService == 'CA') {
          return false;
        }

        if (statusService == 'CX') {
          return false;
        }
        if (statusService == 'RX') {
          return false;
        }
        return true;
      });
      return filterResult;
    },
    replaceNote: (state) => (opt_id, day = null) => {
      const code = opt_id;
      if (!code) return null;

      const categoryIsTitle = (c) => c == 'TGF' || c == 'TIG';
      const categoryIsDescription = (c) => c == 'DGF' || c == 'DEG';
      const sameDay = (e) => day == null || day === '' || e?.day == day;

      const replaceTitleNote = state.replaceNotes.find((e) => e.OPT_ID == code && categoryIsTitle(e.NTS_CATEGORY) && sameDay(e))
        || state.replaceNotes.find((e) => e.OPT_ID == code && categoryIsTitle(e.NTS_CATEGORY));
      const replaceDescriptionNote = state.replaceNotes.find((e) => e.OPT_ID == code && categoryIsDescription(e.NTS_CATEGORY) && sameDay(e))
        || state.replaceNotes.find((e) => e.OPT_ID == code && categoryIsDescription(e.NTS_CATEGORY));

      if (!replaceTitleNote && !replaceDescriptionNote) return null;
      return {
        title: replaceTitleNote?.MESSAGE_TEXT,
        description: replaceDescriptionNote?.MESSAGE_TEXT
      };
    },
    showYOULogo: (state) => {
      if (state.custom != 'YOU') {
        return true;
      }
      if (!state.clientImage) return false;
      return !(!state.finalCustomer && !state.clientImage[0]);
    },
      /*
        Si finalCustomer, que muestre el logo de Say (seria el primer if)
        Si hay logo cliente, siempre se muestra (primer elif)
        Sino hay logo de cliente pero custom = YOU, entonces sale vacio
        else, mostrar logo say
      */
    logoClient: (state) => {
      if (state.finalCustomer) {
        return '';
      }
      if (state.clientImage && state.clientImage[0]) {
        return state.clientImage[0].MESSAGE_TEXT;
      }
      return '';
    },
    logSay: (state) => {
      if (state.finalCustomer) {
        return require('@/assets/trip/img/logo.svg');
      }
      if (state.clientImage && state.clientImage[0]) {
        return '';
      }
      if (state.custom == 'YOU' && (!state.clientImage || !state.clientImage[0])) {
        return '';
      }
      return require('@/assets/trip/img/logo.svg');
    },

    getPassangers: (state) => (optId, date) => {
      const d = moment(date).format('YYYY-MM-DD');
      const array = state.fitPriceDetails || [];
      return array.reduce((nombres, item) => {
        const sDate = moment(item.SERVICEDATE).format('YYYY-MM-DD');
        if (item.OPT_ID == optId && sDate === d && item.Pax_Name && !nombres.includes(item.Pax_Name)) {
          nombres.push(item.Pax_Name);
        }
        return nombres;
      }, []);
    },
    dayList (state, getters) {
      let res = [];
      if (getters.serviceStatusList()) {
        let days = _.map(getters.serviceStatusList(), (e) => {
          let d = moment(e.date, 'YYYY-MM-DD');
          let description = e.Descripcion || '';
          if (e.OWE) description += '<br>' + e.OWE;
          return {
            date: d,
            dateString: d.format('YYYY-MM-DD'),
            day: e.day,
            title: e.Titulo || '',
            code: e.OPT_ID,
            description: description,
            location: e.LocationCode,
            locationName: e.LocationName,
            pcmPkgName: e.pcmPkgName,
            LineType: e.LineType,

          }
        });
        let unique = _.uniqBy(days, 'dateString');
        unique.sort((a, b) => {
          if (a.dateString > b.dateString) return 1;
          if (a.dateString < b.dateString) return -1;
          return 0
        });
        let firstDate = unique[0]? unique[0].date: null;
        res = _.map(unique, (r) => {
          
          let langCode = state.lang  
          if (langCode.toLowerCase() == 'sp') langCode = 'es';
          return {
              date: r.date.locale(langCode).format('DD MMM'),
              dateLong: `${r.date.locale(langCode).format('dddd DD MMM YYYY')}`.toUpperCase(),
              dateString: r.dateString,
              dayNr: r.date.diff(firstDate, 'day') + 1,
              services: _.map(_.filter(days, (d) => {
                  const languageNote = state.languageNotes.find((l) => l.OPT_ID == d.code);
                  const providerId = languageNote ? languageNote.Supplier.trim() : null;
                  if (providerId == '2788') {
                    return false;
                  }
                  return d.dateString == r.dateString;
                }), (t) => {
                  const replaceNote = getters.replaceNote(t.code, t.day);
                  // if (r.date.diff(firstDate, 'day') + 1 == 4) console.log("ReplaceNote:::", replaceNote);
                  let description = replaceNote ? replaceNote.description : t.description;
                  if (t.OWE && state.fitStatus != 'Quote') description += t.OWE;
                  return {
                  title: replaceNote ? replaceNote.title : t.title,
                  code: t.code,
                  day: t.day,
                  description: description,
                  location: t.location,
                  locationName: t.locationName,
                  passangers: getters.getPassangers(t.code, r.date),
                }
              })
            }
        })
      }
      return res;

    },
    cities: (state) => {
      if (!state.tripBookingHotels || !state.tripBookingHotels.hotels) {
        return [];
      }
      
      const unique = _.uniqBy(state.tripBookingHotels.hotels, 'LOCATION');
      return _.map(unique, (r) => {
        return {
          locationCode: r.LOCATION,
          locationName: r?.LocationName,
          hotels: _.filter(state.tripBookingHotels.hotels, (c) => {
            return c.LOCATION == r.LOCATION;
          }).sort((a, b) => {
            if (!a.Comment2) {
              return 1;
            }
            if (!b.Comment2) {
              return -1;
            }
            return a.Comment2 > b.Comment2 ? 1 : -1;
          })
        }
      });
    },
  },
  mutations: {
    setBooking (state, values) {
      if (values) {
        state.allServices = Object.assign([], _.filter(values, (r) => {
          if (r.LocationCode == '000') return false;
          //if (r.ServiceTypeCode == 'IN') return false;
          // if (r.ServiceTypeCode == 'AC' && r.SupplierCode.trim() == '3004') return false;
          if (r.ServiceTypeCode == 'AC') return false;
          if (r.ServiceTypeCode == 'XF') return false;
          if (r.ServiceTypeCode == 'FT') return false;
          if (r.ServiceTypeCode == 'VL') return false;
          if (r.ServiceTypeCode == 'GU') return false;
          if (r.ServiceTypeCode == 'AC' && r.SupplierCode.trim() == '1743') return false;
          if (r.ServiceTypeCode == 'IN' && r.SupplierCode.trim() == '1743') return false;
          return true;
        }));
        state.hotels = Object.assign([], _.filter(values, (r) => {
          if (r.ServiceTypeCode == 'AC') return true;
          return false;
        }))
        let cover = _.find(values, (r) => r.ServiceTypeCode == 'IN');
        if (cover) {
          state.coverImg = `${s3}/OPT_ID.${cover.OPT_ID}.0.html`;
        }
        state.coverService = values.find(r => r.ServiceTypeCode == 'IN');

      }
    },
    setCustom(state) {
      if (custom) {
        state.custom = custom;
        return;
      }
      const host = window.location.host;
      if (host.includes("saysouthamerica.com")) {
        state.custom = "SOU";
      } else if (host.includes("sayyourtrip.com")) {
        state.custom = "YOU";
      } else if (host.includes("sayhueque.com")) {
        state.custom = "SAY";
      } else {
        state.custom = "SAY";
      }
    },
    setReference(state) {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('Code');
      state.reference = code;
    },
    setQuery (state, value) {
      state.query = Object.assign({}, value);
    },
    setHotelPainting (state, value) {
        state.hotelPainting = value
    },
    setSeller (state, seller) {
      state.sellerImg = seller.ProfileImageUrl;
      state.sellerImgBig = seller.ProfileImageUrlBig;
      if (seller.UserProfiles) {
        let profile = _.find(seller.UserProfiles, (r) => r.Language.Code == state.lang);
        if (profile) {
          state.agentDescription = profile.Description;
        }

      }
      state.agentPhone = seller.Phone;
      state.agentName = `${seller.FirstName} - ${seller.LastName}`;
      state.agentMeet = seller.CalendarLink;
      state.agentEmail = seller.Email;
      state.userVideo = seller?.UserVideos?.find(video => {
        if (state.custom == video.Domain  && state.lang == video.Language.Code) {
          return true
        }
      }) || null;
    },
    setNames (state, {values, isPCM}) {
      if (!values) return;
      values.forEach(row => {
        if (row.CATEGORY == 'PAX') state.paxName = row.MESSAGE_TEXT;
        if (isPCM && row.CATEGORY == 'VIA') state.tripName = row.MESSAGE_TEXT;
        if (row.CATEGORY == 'OBV') state.obsevationNotes = row.MESSAGE_TEXT;
        if (row.CATEGORY == 'OBS') state.obsevationNotes = row.MESSAGE_TEXT;
      });
    },
    setPrices (state, values) {
      state.prices = values;
    },
    setFITPrices (state, values) {
      state.fitPrices = values;
    },
    setFlights (state, values) {
      state.flightNotes = values;
    },
    setLanguageNotes (state, values) {
      var services = state.allServices || [];
      values = _.map(values, (r) => {
        return {
          ...r,
          MESSAGE_TEXT: r.NTS_CATEGORY == 'OIE'? r.MESSAGE_TEXT.replace(/\n/g, '<br>') : r.MESSAGE_TEXT
        };
      });
      var languageNotes = values || [];
      const oweNotes = values.filter(r => r.NTS_CATEGORY == 'OWE');
      state.languageNotes = _.filter(languageNotes, (r) => r.LocationCode != '000' && (r.ServiceTypeCode != 'AC' || r.Supplier.trim() != '1743'));
      if (languageNotes) {
        const fitHotelsRaw = values.filter(note => note.Service === 'AC' && (note.MESSAGE_CODE == 'AC' || note.MESSAGE_CODE == 'PK') && note.Supplier.trim() != '1743');
        const fitHotelsMap = new Map();
        fitHotelsRaw.forEach(hotel => {
          if (!fitHotelsMap.has(hotel.OPT_ID)) {
            fitHotelsMap.set(hotel.OPT_ID, hotel);
          }
        });
        const fitHotels = Array.from(fitHotelsMap.values());

        fitHotels.forEach(hotel => {
          const optId = hotel.OPT_ID;
          const allData = state.hotels.find(h => h.OPT_ID === optId);
          if ((allData?.SupplierCode?.includes('TEXT') || allData?.SupplierCode?.includes('3004'))) { 
            hotel.FormattedRooms = allData.DESCRIPTION.trim();
          }
          else if (allData) {
            const relatedRooms = state.hotels.filter(service =>
              service.CheckIn === allData.CheckIn &&
              service.CheckOut === allData.CheckOut
            );
            hotel.RoomType = allData?.RoomType || '';
            hotel.RoomCount = allData?.RoomCount || 0;
            hotel.RelatedRooms = relatedRooms || [];
            let roomDescription = '';
            if (relatedRooms && relatedRooms.length > 0) {
              const cleanMessageText = (text) => text.replace(/<[^>]*>/g, '').trim();
              roomDescription = relatedRooms.map(room => {
                const note = fitHotelsMap.get(room.OPT_ID) || hotel;
                if (!note.MESSAGE_TEXT) return `${room.RoomCount} ${room.RoomType} room`;
                return `${room.RoomCount} ${room.RoomType} ${cleanMessageText(note.MESSAGE_TEXT)}`;
              }).join(' + ');
            } else if (allData.RoomCount && allData.RoomType) {
              roomDescription = `${allData.RoomCount} ${allData.RoomType} room${allData.RoomCount > 1 ? 's' : ''}`;
            }
            hotel.FormattedRooms = roomDescription;
          }
        });
        state.fitHotels = fitHotels;
        services = services.map(service => {
          let updatedService = { ...service };
          
          const matchingNote = languageNotes.find(note => note.OPT_ID === service.OPT_ID && note.NTS_CATEGORY === 'ODE' && note.day == service.day);
          if (matchingNote) {
            updatedService.Titulo = matchingNote.MESSAGE_TEXT;
            updatedService.pcmPkgName = matchingNote.pcmPkgName;
            updatedService.LineType = matchingNote.LineType;
            updatedService.NTS_CATEGORY = matchingNote.NTS_CATEGORY;
          }
          
          const matchingNote2 = languageNotes.find(note => note.OPT_ID === service.OPT_ID && note.NTS_CATEGORY === 'OIE' && note.day == service.day);
          if (matchingNote2) {
            updatedService.Descripcion = matchingNote2.MESSAGE_TEXT;
            updatedService.pcmPkgName = matchingNote2.pcmPkgName;
            updatedService.LineType = matchingNote2.LineType;
            updatedService.NTS_CATEGORY = matchingNote2.NTS_CATEGORY;
          }
          
          const noteOWE = oweNotes.find(note => note.OPT_ID == service.OPT_ID);
          if (noteOWE && noteOWE.MESSAGE_TEXT && state.fitStatus != 'Quote') {
            updatedService.OWE = noteOWE.MESSAGE_TEXT;
          }
          if (updatedService.LineType == 'Package Component') {
            const noteHeaderODE = languageNotes.find(note => note.pcmPkgName === updatedService.pcmPkgName && note.LineType === 'Package Header' && note.day == service.day && note.NTS_CATEGORY === 'ODE');
            const noteHeaderOIE = languageNotes.find(note => note.pcmPkgName === updatedService.pcmPkgName && note.LineType === 'Package Header' && note.day == service.day && note.NTS_CATEGORY === 'OIE');
            const noteHeaderOWE = languageNotes.find(note => note.pcmPkgName === updatedService.pcmPkgName && note.LineType === 'Package Header' && note.day == service.day && note.NTS_CATEGORY === 'OWE');
            if (noteHeaderODE && noteHeaderODE.MESSAGE_TEXT && noteHeaderODE.MESSAGE_TEXT.length > 0) {
              updatedService.Titulo = '';
            }
            if (noteHeaderOIE && noteHeaderOIE.MESSAGE_TEXT && noteHeaderOIE.MESSAGE_TEXT.length > 0) {
              updatedService.Descripcion = '';
            }
            if (noteHeaderOWE && noteHeaderOWE.MESSAGE_TEXT && noteHeaderOWE.MESSAGE_TEXT.length > 0) {
              updatedService.OWE = '';
            }
          }
          
          return updatedService;
        });
      }
      state.services = services;
      state.coverNote = values.find(r => r.NTS_CATEGORY == 'OIP');

    },
    setLang (state, lang) {
      state.lang = lang;
    },
    setHidePrices (state, hidePrices) {
      state.hidePrices = hidePrices;
    },
    //
    setFITBooking (state, values) {
      if (values && values.length > 0) {
        //state.fitShowPrices = values[0].MostrarPrecios;
        state.fitPaxDetail = values[0].Nominar;
        state.fitGuestRelation = values[0].GR;
        state.fitStatus = values[0].Status;
        state.allServices = Object.assign([], _.filter(values, (r) => {
          if (r.LocationCode == '000') return false;
          //if (r.ServiceTypeCode == 'IN') return false;
          if (r.ServiceTypeCode == 'AC') return false;
          if (r.ServiceTypeCode == 'XF') return false;
          if (r.ServiceTypeCode == 'FT') return false;
          if (r.ServiceTypeCode == 'VL') return false;
          if (r.ServiceTypeCode == 'GU') return false;
          if (r.ServiceTypeCode == 'AC' && r.SupplierCode.trim() == '1743') return false;
          if (r.ServiceTypeCode == 'IN' && r.SupplierCode.trim() == '1743') return false;
          return true;
        }));
        state.hotels = Object.assign([], _.filter(values, (r) => {
          if (r.ServiceTypeCode == 'AC') return true;
          return false;
        }))
        let cover = _.find(values, (r) => r.ServiceTypeCode == 'IN');
        if (cover) {
          state.coverImg = `${s3}/OPT_ID.${cover.OPT_ID}.0.html`;
        }
        state.coverService = values.find(r => r.ServiceTypeCode == 'IN');

      }
      if (!state.tripName) {
        values.forEach(row => {
          if (row.BookingNameAlias) {
            state.tripName = row.BookingNameAlias;
            return;
          }
        });
      }
      if (!state.modifiedUTC) {
        values.forEach(row => {
          if (row.ModifiedUTC) {
            state.modifiedUTC = row.ModifiedUTC;
            return;
          }
        });
      }
    },
    setGrUser (state, values) {
      const data = Object.assign({}, values);
      const userProfile = Object.assign({}, data.UserProfiles[0]);
      const langUser = data.UserProfiles.find((r) => r.Language.Code == state.lang);
      if (langUser) data.Description = langUser.Description
      else data.Description = userProfile.Description;
      state.grUser = data;
    },
    setFITPriceDetails (state, values) {
      state.fitPriceDetails = values;
    },
    setClientImage (state, values) {
      state.clientImage = values;
    },
    setPaxPrincipal (state, values) {
      state.paxPrincipal = values?.[0]?.PaxName || null;
    },
    setAgent (state, values) {
      let agent = values?.trim() || null;
      if (agent && agent != '657' && agent != '661') {
        state.agent = agent;
      }
      if (agent && (agent == '657' || agent == '661')) {
        state.finalCustomer = true;
      }
    },
    setReplaceNotes (state, values) {
      state.replaceNotes = values;
    },
    setDateView (state, value) {
      let dateView = value?.trim() || null;
      if (!dateView) dateView = false;
      else if (dateView == "SI") dateView = true;
      else if (dateView == "NO") dateView = false;
      else if (dateView == "1") dateView = true;
      else dateView = false;
      state.noDateView = dateView;
    },
    setUser (state, values) {
      state.isUser = !!values;
    },
    setBookingHotels (state, values) {
      state.tripBookingHotels = values;
    },
    setCurrencyRate (state, values) {
      state.currencyRate = values.ConvertValue;
      state.currency = values.ToCurrency;
    },
    setExpireDays (state, values) {
      state.expireDays = values;
    },
  }
})

export default store;
